import { Injectable } from '@angular/core';
import { AdministratorFacade, getRolesAndPermission } from '@piqet-angular/data';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  rolesModuleName,
  subModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ColDef } from 'ag-grid-community';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RecycledMaterialDataGridService {
  event: any;
  recycledAdminPayload: any;
  editRecycledMaterial = new Subject<[any, any, any]>();
  editRecycledMaterialData$ = this.editRecycledMaterial.asObservable();
  deleteRecycledMaterial = new Subject<[any]>();
  deleteRecycledMaterialData$ = this.deleteRecycledMaterial.asObservable();

  constructor(public administratorFacade: AdministratorFacade, private swalService: SwalService) {}

  getAdministratorRecycledColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'MaterialCategoryName',
      headerName: 'Material category',
      field: 'materialCategoryName',
      cellClass: 'my-permission-cursor-pointer',
      // sort: 'asc',
      wrapText: true,
      filter: 'agTextColumnFilter',
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        cellElement.style.textDecoration = 'underline';
        const showEdit = this.isAccess() ? this.isAccess().isEdit : true;
        if (showEdit) {
          cellElement.style.cursor = 'pointer';
        }
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          const showEdit = this.isAccess() ? this.isAccess().isEdit : true;
          showEdit &&
            this.editRecycledMaterial.next([
              params.data.materialId,
              params.data.regionId,
              'Review material detail',
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialCode',
      headerName: 'Material code',
      field: 'materialCode',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialName',
      headerName: 'Material',
      field: 'materialName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RegionCode',
      headerName: 'Region code',
      field: 'regionCode',
      filter: 'agTextColumnFilter',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RegionName',
      headerName: 'Region',
      field: 'regionName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Organization',
      field: 'organizationName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      maxWidth: grid_widths_map.sm_column_xs,
      cellRendererParams: {
        showEdit: this.isAccess() ? this.isAccess().isEdit : true,
        showDelete: this.isAccess() ? this.isAccess().isDelete : true,
        value: 'admin-recycled',
        editData: (data: any) => {
          this.editRecycledMaterial.next([data.materialId, data.regionId, 'Review RMI detail']);
        },
        deleteData: (data: any) => {
          this.deleteConfirmation(data);
        },
      },
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  isAccess = () => {
    return getRolesAndPermission(
      rolesModuleName.DataManageMaterialImpactRecycleImpact,
      subModuleName.materialImpactDataModule
    );
  };

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getAdministratorRecycledColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.recycledAdminPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'MaterialCategoryName',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteRecycledMaterial.next([data]);
      }
    });
  }
}
